import { useHistory } from 'react-router-dom'
import { Typography } from '@mui/material'
import { useSelector } from 'src/utils/store'
import { formatDatePlusThree } from 'src/utils/formatDate'
import { useBlockPopAction } from 'src/hooks/useBlockPopAction'
import Page from 'src/features/restocking/components/RestockingWebAppForm/components/Page/Page'
import * as S from './FinishedRestockingPage.styles'

const FinishedRestockingPage: React.FC = () => {
  const { user } = useSelector((state) => state.restocking)
  const history = useHistory()

  const navigateToBadgePage = () => history.push('/restocking/webapp/badge')

  useBlockPopAction()

  const overviewFinishedRestocking = () => {
    if (!user.finishedPage) return null

    const {
      startedAt,
      finishedAt,
      totalItems,
      totalItemsToRestock,
      totalVolume,
      message,
    } = user.finishedPage

    return (
      <S.OverviewContainer>
        <Typography pt={4} style={{ fontSize: '26px', fontWeight: 800 }}>Reposição finalizada</Typography>
        <Typography variant='h6'>{`Horário Início: ${formatDatePlusThree(startedAt)}`}</Typography>
        <Typography variant='h6'>{`Horário Fim: ${formatDatePlusThree(finishedAt)}`}</Typography>
        <Typography variant='h6'>{`Total de itens repostos : ${totalItems}/${totalItemsToRestock}`}</Typography>
        <Typography variant='h6'>{`Total de volumes repostos: ${totalVolume}`}</Typography>
        {message && <Typography variant='subtitle2' color='red'>{message}</Typography>}
      </S.OverviewContainer>
    )
  }

  return (
    <Page headerTitle='Reposição' hasBackButton={false}>
      {overviewFinishedRestocking()}
      <S.Form>
        <S.ContainerButton>
          <S.CustomButton
            title='Próximo'
            bgColor='lightBlue5'
            hoverColor='darkBlueHover'
            letterColor='white'
            data-testid='next-button-test-id'
            onClick={navigateToBadgePage}
          />
        </S.ContainerButton>
      </S.Form>
    </Page>
  )
}

export default FinishedRestockingPage
